// Category pricing helpers shared by the host + admin rate editors.
export const RATE_CATEGORIES = ["Economy", "SUV", "Minivan", "Cargo Van", "Pickup Truck", "Luxury"];
const tierOf = (t, d) => Number(t?.[d] ?? t?.[String(d)] ?? 0);

// Scale a category preset's whole tier table by a target weekly (7-day) price.
export function scaleFromWeekly(preset, weekly) {
  const w = Number(weekly);
  const pw = tierOf(preset?.tiers, 7);
  if (!preset || !w || !pw) return null;
  const f = w / pw;
  const tiers = {};
  [2, 3, 4, 5, 6, 7].forEach((d) => { tiers[d] = Math.round(tierOf(preset.tiers, d) * f); });
  return { tiers, extra_day: Math.round(Number(preset.extra_day) * f), daily_start: Math.round(Number(preset.daily_start) * f) };
}
